import React, { useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { getBEMClasses } from 'apex-web/lib/helpers/cssClassesHelper';
import BalancesItem from './BalanceItemComponent';
import Spinner from 'apex-web/lib/components/common/Spinner/Spinner';
import Modal from 'apex-web/lib/components/common/Modal/Modal';
import { formatNumberToLocale } from '../../helpers/numberFormatter';
import BigNumber from 'bignumber.js';

import './BalancesListComponent.css';

const productBalancesClasses = getBEMClasses('product-balances');
const layoutClasses = getBEMClasses('dashboard-page');

const BalancesListComponent = props => {
  const { isBasicView, t, fetching, balances, isDarkTheme } = props;
  const [balancesModalOpen, setBalancesModalOpen] = useState(false);

  const items = balances.map(item => {
    return (
      <BalancesItem
        key={item.ProductId}
        balance={item}
        isDarkTheme={isDarkTheme}
      />
    );
  });

  const totalBalance = useMemo(
    () =>
      balances.reduce((acc, item) => {
        const formattedNotionalValue = item.NotionalValue;
        return acc.plus(formattedNotionalValue);
      }, new BigNumber(0)),
    [balances]
  );

  const openBalancesModal = useCallback(() => {
    setBalancesModalOpen(true);
  }, []);

  const closeBalancesModal = useCallback(() => {
    setBalancesModalOpen(false);
  }, []);

  return (
    <React.Fragment>
      <div className={layoutClasses('balances-header')}>
        <span>Balances</span>
        {!fetching && (
          <span>{formatNumberToLocale(totalBalance, 2)} USD</span>
        )}
      </div>
      {fetching ? (
        <Spinner />
      ) : (
        <React.Fragment>
          <div
            className={productBalancesClasses('container', {
              'basic-in-card': isBasicView
            })}>
            <div className={productBalancesClasses('wrapper')}>{items}</div>
          </div>
          {isBasicView && balances.length > 0 ? (
            <button
              type="button"
              className={layoutClasses('balances-view-more')}
              onClick={openBalancesModal}
              aria-haspopup="dialog"
              aria-expanded={balancesModalOpen}
            >
              {t('View more balances')}
            </button>
          ) : null}
        </React.Fragment>
      )}
      {isBasicView && balances.length > 0 && (
        <Modal
          isOpen={balancesModalOpen}
          close={closeBalancesModal}
          onCancel={closeBalancesModal}
          title={t('Balances')}
        >
          <div className={layoutClasses('balances-all-modal')}>
            <div className={layoutClasses('balances-all-modal-hero')}>
              <p className={layoutClasses('balances-all-modal-hero-kicker')}>
                {t('Total portfolio value')}
              </p>
              <p className={layoutClasses('balances-all-modal-hero-amount')}>
                <span className={layoutClasses('balances-all-modal-hero-value')}>
                  {formatNumberToLocale(totalBalance, 2)}
                </span>
                <span className={layoutClasses('balances-all-modal-hero-unit')}>
                  USD
                </span>
              </p>
            </div>
            <div className={layoutClasses('balances-all-modal-list-wrap')}>
              <div className={productBalancesClasses('modal-scroll')}>
                {items}
              </div>
            </div>
          </div>
        </Modal>
      )}
    </React.Fragment>
  );
};

BalancesListComponent.defaultProps = {
  isBasicView: false
};

BalancesListComponent.propTypes = {
  isBasicView: PropTypes.bool,
  t: PropTypes.func.isRequired,
  fetching: PropTypes.bool,
  balances: PropTypes.array,
  isDarkTheme: PropTypes.bool
};

export default BalancesListComponent;
